import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Col, Label, Row } from "reactstrap";
import { toast } from "react-toastify";
toast.configure()
import "react-toastify/dist/ReactToastify.css";
import { Driver } from "models/Driver";
import { AdminService } from "services/AdminService";
import { Puff } from "react-loader-spinner";
import { AuthService } from "services/AuthService";

export interface DriverDetailsModalProps {
  isOpen: boolean;
  handleIsOpen: () => void;
  driverId: string;
}

const getInitials = (name: string) => {
  if (!name) return "";
  let initials;
  const nameSplit = name.split(" ");
  const nameLength = nameSplit.length;
  if (nameLength > 1) {
    initials =
      nameSplit[0].substring(0, 1) +
      nameSplit[nameLength - 1].substring(0, 1);
  } else if (nameLength === 1) {
    initials = nameSplit[0].substring(0, 1);
  } else return "";

  return initials.toUpperCase();
};

const createImageFromInitials = (size: number, name: string, color: string) => {
  if (!name) return "";
  name = getInitials(name);

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) return "";
  
  canvas.width = canvas.height = size;

  context.fillStyle = color;
  context.fillRect(0, 0, size, size);

  context.fillStyle = "#ffffff";
  context.textBaseline = 'middle';
  context.textAlign = 'center';
  context.font = `${size/2}px Roboto`;
  context.fillText(name, (size/2), (size/2));

  return canvas.toDataURL();
};

const ProfileImage = ({ photoId, name }: { photoId?: string, name: string }) => {
  const [imgSrc, setImgSrc] = useState<string>("");

  useEffect(() => {
        console.log("photid",photoId)
    if (photoId) {
  
        AuthService.getProfileImage(photoId)
        .then(response => {
          const rawBinary = response; 
          const blob = new Blob([rawBinary as any], { type: 'image/jpeg' }); 
          const reader = new FileReader();     
          reader.onload = () => {
            if (typeof reader.result === 'string') {
              setImgSrc(reader.result);
            }
          };    
          reader.readAsDataURL(blob);
        })
        .catch(err => {
          console.error("Error loading image:", err);
          // If there's an error loading the image, fall back to initials
          setImgSrc(createImageFromInitials(100, name, "#ff115a"));
        });
    } else {
      // If no photoId, use initials
      setImgSrc(createImageFromInitials(100, name, "#ff115a"));
    }
  }, [photoId, name]);

  return (
    <div className="d-flex justify-content-center align-items-center">
      {!photoId ? (
        <div className="rounded-circle d-flex justify-content-center align-items-center" 
          style={{
            width: "200px",
            height: "200px",
            backgroundColor: "#ff115a",
            color: "white",
            fontSize: "48px",
            fontWeight: "bold",
            // border: "2px solid #ff115a"
          }}>
          {getInitials(name)}
        </div>
      ) : (
        <img 
          className="rounded-circle" 
          src={imgSrc} 
          alt="profile"
          style={{
            width: "200px",
            height: "200px",
            objectFit: "cover",
            // border: "2px solid #ff115a"
          }}
        />
      )}
    </div>
  );
};

const DriverDetailsModal: React.FC<DriverDetailsModalProps> = ({ isOpen, handleIsOpen, driverId}: DriverDetailsModalProps) => {
  const [driver, setDriver] = useState({} as Driver);
  const [isLoading, setIsloading] = useState<boolean>(true);

  useEffect(() => {
    setIsloading(true);
    AdminService.getDriverById(driverId)
      .then(res => {
        if (res.success) {
            setDriver(res.data);
          setIsloading(false);
        } else {
          setDriver({});
          setIsloading(false);
        }
     
      })
      .catch(err => {
        setIsloading(false);
        console.error(err);
      });
  }, [isOpen]);


  return (
    <React.Fragment>
      {isLoading && <div className="d-flex justify-content-center align-items-center " style={{ height: "500px" }}>
                  <Puff color="#FFD0B8" height={50} width={50} />
                </div>}  
      <Modal className="modal-dialog modal-dialog-centered" isOpen={isOpen} toggle={handleIsOpen} size="xl">
        <ModalHeader className="text-center" toggle={handleIsOpen}>
          Driver Details
        </ModalHeader>
        <ModalBody className="overflow-auto">
          <div className="container-fluid">
            <Row>
              <Col md="8">
                <div className="driver-details-container p-3">
                  <Row className="mb-3">
                    <Col sm="5"><strong>Name</strong></Col>
                    <Col sm="7">{driver?.firstName} {driver?.lastName}</Col>
                  </Row>
                  <Row className="mb-3">
                    <Col sm="5"><strong>Username</strong></Col>
                    <Col sm="7">{(driver as any)?.userName || "N/A"}</Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col sm="5"><strong>Address</strong></Col>
                    <Col sm="7">
                      {driver?.address?.city}
                    </Col>
                  </Row>                  
                  <Row className="mb-3">
                    <Col sm="5"><strong>Email</strong></Col>
                    <Col sm="7">{driver?.email}</Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col sm="5"><strong>Contact Phone</strong></Col>
                    <Col sm="7">{driver?.phoneNumber}</Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col sm="5"><strong>Percentage</strong></Col>
                    <Col sm="7">{driver?.percentage}%</Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col sm="5"><strong>Mobile Device Type</strong></Col>
                    <Col sm="7">{driver?.mobileDeviceType}</Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col sm="5"><strong>Vehicle Type</strong></Col>
                    <Col sm="7">{driver?.vehicleType || "N/A"}</Col>
                  </Row>

                  {/* Vehicle Details Section */}
                  <Row className="mb-3">
                    <Col sm="5"><strong>Vehicle Brand</strong></Col>
                    <Col sm="7">{(driver as any)?.vehicle?.brand || "N/A"}</Col>
                  </Row>

                  <Row className="mb-3">
                    <Col sm="5"><strong>Vehicle Model</strong></Col>
                    <Col sm="7">{(driver as any)?.vehicle?.model || "N/A"}</Col>
                  </Row>

                  <Row className="mb-3">
                    <Col sm="5"><strong>Vehicle Year</strong></Col>
                    <Col sm="7">{(driver as any)?.vehicle?.year || "N/A"}</Col>
                  </Row>

                  <Row className="mb-3">
                    <Col sm="5"><strong>Vehicle Plate Number</strong></Col>
                    <Col sm="7">{(driver as any)?.vehicle?.license || "N/A"}</Col>
                  </Row>

                  {/* Bank Details Section */}
                  <Row className="mb-3">
                    <Col sm="5"><strong>Bank Name</strong></Col>
                    <Col sm="7">{(driver as any)?.bankDetails?.bankName || "N/A"}</Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col sm="5"><strong>Account Number</strong></Col>
                    <Col sm="7">{(driver as any)?.bankDetails?.accountNumber || "N/A"}</Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col sm="5"><strong>Transit Number</strong></Col>
                    <Col sm="7">{(driver as any)?.bankDetails?.transitNumber || "N/A"}</Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col sm="5"><strong>Institution Number</strong></Col>
                    <Col sm="7">{(driver as any)?.bankDetails?.institutionNumber || "N/A"}</Col>
                  </Row>

                  <Row className="mb-3">
                    <Col sm="5"><strong>Registered HST Number</strong></Col>
                    <Col sm="7">{(driver as any)?.bankDetails?.registeredHstNumber || "N/A"}</Col>
                  </Row>
                </div>
              </Col>
              

              <Col md="4">
                <div className="d-flex flex-column align-items-center p-3" style={{  height: "100%" }}>
                  <div className="mb-4">
                    
                    <ProfileImage
                      photoId={(driver as any)?.photoId}
                      name={`${driver?.firstName} ${driver?.lastName}`}
                    />
                  </div>
                  
                
                </div>
              </Col>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex flex-row flex-wrap justify-content-end">
            {/* Keep any footer buttons you need */}
          </div>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default DriverDetailsModal;